import { Component, OnInit, SimpleChanges } from '@angular/core';
import { ViewCell } from '../ofbiz-form-model';

export interface innerField{
  name:string;
  value?:string;
  title?:string;
}

@Component({
  selector: 'ngx-ofbiz-cell-composite',
  templateUrl: './ofbiz-cell-composite.component.html',
  styleUrls: ['./ofbiz-cell-composite.component.scss']
})
export class OfbizCellCompositeComponent implements ViewCell, OnInit {
  field:any;
  value: string | number;
  rowData: any;
  innerFields:innerField[];
  ngOnInit(): void {
    //console.log(this.field,this.rowData);
    if(this.field.innerFields != undefined){
      this.innerFields = this.field.innerFields;
      this.innerFields.forEach(innerField => {
        //console.log(innerField.title);
        innerField.value = this.rowData[innerField.name];
      })
      //console.log(this.innerFields);
    }
  }
  

}
